var createFlow=require("../internal/createFlow"),flow=createFlow();module.exports=flow;